module.exports = __webpack_public_path__ + "static/media/material-pearl.9d711ae9.svg";